module.exports = __webpack_public_path__ + "img/DrMuhsin-ShynbwniBard.a17a6de7.jpg";